import view from '../../helpers/view';
import { defaultCase, flowDefault } from "../../helpers/flow"
import tieneDeuda from '../../controllers/tieneDeuda';

export const flowNoSuscriptor = (code, isPdf) => {
    switch (code) {
        case '07': //TIENE DEUDA
            tieneDeuda();
            break;
        case '04': //NO ASOCIADO
        case '08':
        case '13': //CLASSIC
        case '14':
        case '30':
        case '31':
            view.hidePreloader();
            flowDefault();
            break;
        case '0001':
        default:
            defaultCase(code, isPdf);
            break;
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/flow/flowNoSuscriptor.js